<template>
  <v-content>
    <template v-if="$store.state.providerToken">
      <provider-nav />
      <v-container>
        <router-view />
      </v-container>
    </template>
    <v-container v-else>
      <v-layout justify-center class="mt-5">
        <v-flex xs12 sm6>
          <v-alert type="warning">
            You must be logged in to access this page.
            <router-link :to="{ name: 'Provider-Login' }" class="ml-2"
              >Log in</router-link
            >
          </v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import ProviderNav from "@/components/ProviderNav.vue";

export default {
  name: "ProviderDashboard",
  components: { ProviderNav }
};
</script>
